import RencamSchedeMorteExportExcelList from "./pages/RencamSchedeMorteExportExcelList";

export default {
    RencamSchedeMorteExportExcelList,
};
